import type { AlertConfigurationRule } from '@rtkwlf/rendall';

import type { FormData } from './country-user-white-list-form-values';

function convertToArray(input: string | string[] | undefined): string[] {
  if (typeof input === 'string') {
    return [input];
  } else if (Array.isArray(input)) {
    return input;
  } else {
    return [];
  }
}

export const toFormData = (
  values?: AlertConfigurationRule['data'],
): FormData => {
  return {
    countries: convertToArray(values?.country),
    usernames: convertToArray(values?.user),
    duration: [values?.start, values?.expiry],
  };
};
export const fromFormData = (
  formData: FormData,
): AlertConfigurationRule['data'] => {
  return {
    country: formData.countries,
    user: formData.usernames,
    start: formData.duration?.[0],
    expiry: formData.duration?.[1],
  };
};
